module.exports = __webpack_public_path__ + "img/economy-report.00af800c.svg";